export enum Keys {
  //auth
  INSERT_MOBILE_MUT = "insert_mobile_mut",
  VERIFY_CODE_MUT = "verify_code_mut",
  LOGOUT_MUT = "logout_mut",
  LOGIN_TO_CTO_ACCOUNT_MUT = "logout_mut",
  AUTH_QRY = "auth_qry",

  // user
  USER_QRY = "user_qry",
  EDIT_USER_MUT = "edit_user_mut",
  UPDATE_COMPANY = "update_company",
  USERS = "users",

  // default
  HOME_QRY = "home_qry",
  ABOUT_US_QRY = "about_us_qry",
  CONTACT_US_QRY = "contact_us_qry",
  VERSION_QRY = "version_qry",

  // address
  CITIES_BY_NAME_QUERY = "cities_by_name_qry",
  COUNTRIES_QRY = "countries_qry",
  PROVINCES_QRY = "provinces_qry",
  CITIES_QRY = "cities_qry",
  // ----
  CREATE_COUNTRY_MUT = "create_country_mut",
  CREATE_ZONE_MUT = "create_zone_mut",
  CREATE_CITY_MUT = "create_city_mut",

  // admin
  ADMIN_QRY = "admin_qry",
  ADMINS_QRY = "admin_qry",
  ADD_ADMIN_MUT = "add_admin_mut",
  EDIT_ADMIN_MUT = "edit_admin_mut",
  DELETE_ADMIN_MUT = "delete_admin_mut",

  // attribute
  ATTRIBUTE_QRY = "attribute_qry",
  ATTRIBUTES_QRY = "attributes_qry",
  ADD_ATTRIBUTE_MUT = "add_attribute_mut",
  EDIT_ATTRIBUTE_MUT = "edit_attribute_mut",
  DELETE_ATTRIBUTE_MUT = "delete_attribute_mut",
  CATEGORY_ATTRIBUTES_QRY = "category_attributes_qry",

  // category
  CATEGORY_QRY = "category_qry",
  CATEGORIES_QRY = "categories_qry",
  ADD_CATEGORY_MUT = "add_category_mut",
  EDIT_CATEGORY_MUT = "edit_category_mut",
  DELETE_CATEGORY_MUT = "delete_category_mut",

  // seller
  SELLER_QRY = "seller_qry",
  SELLERS_QRY = "sellers_qry",
  ADD_SELLER_MUT = "add_seller_mut",
  EDIT_SELLER_MUT = "edit_seller_mut",
  DELETE_SELLER_MUT = "delete_seller_mut",

  // product
  PRODUCT_QRY = "product_qry",
  PRODUCTS_QRY = "products_qry",
  ADD_PRODUCT_MUT = "add_product_mut",
  EDIT_PRODUCT_MUT = "edit_product_mut",
  DELETE_PRODUCT_MUT = "delete_product_mut",
  ADD_PRODUCT_PIC_MUT = "add_product_pic_mut",
  DELETE_PRODUCT_PIC_MUT = "delete_product_pic_mut",
  VARIANT_PRODUCT_ATTRIBUTES_QRY = "variant_product_attributes_qry",

  // customer
  CUSTOMER_PHONES_TYPES_QRY = "customer_phones_types_qry",
  CUSTOMER_SOCIALS_TYPES_QRY = "customer_socials_types_qry",
  CUSTOMERS_STATUS_QRY = "customer_status_qry",
  CUSTOMERS_BASE_OPTIONS_QRY = "customer_base_options_qry",
  CUSTOMER_FAMILIARITY_WAYS_QRY = "customer_familiarity_ways_qry",
  CUSTOMER_RELIGION_QRY = "customer_religion_qry",
  CUSTOMER_CATEGORIES_QRY = "customer_categories_qry",
  CUSTOMER_CREDITS_QRY = "customer_credits_qry",
  CO_WORKERS_QRY = "co_workers_qry",
  CUSTOMERS_QRY = "customers_qry",
  CUSTOMERS_REPORT_QRY = "customers_report_qry",
  CUSTOMER_QRY = "customer_qry",
  ADD_CUSTOMER_MUT = "add_customer_mut",
  EDIT_CUSTOMER_MUT = "edit_customer_mut",
  DELETE_CUSTOMER_MUT = "delete_customer_mut",
  CHANGE_CUSTOMERS_GROUP = "change_customers_group",

  // reminder
  REMINDER_TYPES_QRY = "reminders_type_qry",
  REMINDER_QRY = "reminder_qry",
  REMINDERS_QRY = "reminders_qry",
  TASKS_QRY = "tasks_qry",
  REMINDERS_ARCHIVE_QRY = "reminders_archive_qry",
  ADD_REMINDER_MUT = "add_reminder_mut",
  EDIT_REMINDER_MUT = "edit_reminder_mut",
  DELETE_REMINDER_MUT = "delete_reminder_mut",

  // factor
  FACTOR_QRY = "factor_qry",
  FACTORS_QRY = "factors_qry",
  TODAY_FACTORS_QRY = "today_factors",
  ADD_FACTOR_MUT = "add_factor_mut",
  EDIT_FACTOR_MUT = "edit_factor_mut",
  DELETE_FACTOR_MUT = "delete_factor_mut",
  FACTOR_STATUSES_QRY = "factor_statuses_qry",
  CHANGE_FACTOR_STATUS_MUT = "change_factor_status_mut",
  FACTOR_MAIN_STATUS_QRY = "factor_main_status_qry",
  CHANGE_FACTOR_MAIN_STATUS_MUT = "change_factor_main_status_mut",

  // note
  NOTE_QRY = "note_qry",
  NOTES_QRY = "notes_qry",
  ADD_NOTE_MUT = "add_note_mut",
  EDIT_NOTE_MUT = "edit_note_mut",
  DELETE_NOTE_MUT = "delete_note_mut",

  // wholesaler
  WHOLESALER_QRY = "seller_qry",
  WHOLESALERS_QRY = "sellers_qry",
  CONFIRM_WHOLESALER_MUT = "confirm_wholesaler_mut",
  WHOLESALERS_CHANGE_STATUS_MUT = "wholesaler_change_status_mut",

  // report
  REPORTS_QRY = "reports_counts_qry",
  SALE_REPORT_QRY = "sale_report_qry",
  SELLER_REPORT_QRY = "seller_report_qry",
  PRODUCT_REPORT_QRY = "product_report_qry",
  CUSTOMER_REPORT_QRY = "customer_report_qry",

  // history
  HISTORY_QRY = "history_qry",

  // company
  COMPANIES_QRY = "companies_qry",
  COMPANY_QRY = "company_qry",

  // organization
  GET_ROLES_QRY = "get_roles_qry",
  EMPLOYEES = "employees",
  GET_PERMISSIONS_QRY = "get_permission_qry",
  EMPLOYEE_PERMISSIONS = "employee_permissions",
  GET_SECTIONS_PERMISSIONS_QRY = "get_sections_permission_qry",
  CREATE_ROLE_MUT = "create_role_mut",
  UPDATE_ROLE_MUT = "update_role_mut",
  DELETE_ROLE_MUT = "delete_role_mut",
  CREATE_EMPLOYEE = "create_employee",
  UPDATE_EMPLOYEE = "update_employee",
  DELETE_EMPLOYEE_MUT = "delete_employee_mut",
  UPDATE_EMPLOYEE_PERMISSIONS_MUT = "update_employee_permissions_mut",

  // corporation
  CORPS = "corps",
  CREATE_CORP = "create_corp",
  UPDATE_CORP = "update_corp",
  DELETE_CORP = "delete_corp",

  // base
  TYPE_OF_MEETINGS = "type_of_meetings",
  CREATE_TYPE_OF_MEETING = "create_type_of_meeting",
  UPDATE_TYPE_OF_MEETING = "update_type_of_meeting",
  DELETE_TYPE_OF_MEETING = "delete_type_of_meeting",
  APK_VERSION = "apk_version",
  UPDATE_APK_VERSION = "update_apk_version",
}
